goog.provide("Ntry.OperationPopup");

goog.require("Ntry.STATIC");
goog.require("Ntry.Engine");

Ntry.OperationPopup = {
    pageIndex: 0,
    setPopupLayout: function (popup) {
        this.pageIndex = 0;
        this.stepBadge_ = Entry.Dom('div', {
            class: 'entryPopupHelperStep'
        });
        this.leftButton_ = Entry.Dom('div', {
            class: 'entryPopupHelperLeft'
        });
        this.leftButton_.bindOnClick((function () {
            this.setPrevStep();
        }).bind(this));

        this.rightButton_ = Entry.Dom('div', {
            class: 'entryPopupHelperRight'
        });
        this.rightButton_.bindOnClick((function () {
            this.setNextStep();
        }).bind(this));

        this.view_ = Entry.Dom('div', {
            class: 'entryPopupHelperView'
        });
        this.content_ = Entry.Dom('div', {
            class: 'entryPopupHelperContent'
        });
        popup.addClass('operationPopupWindow');
        popup.popupWrapper_.append(this.stepBadge_);
        popup.popupWrapper_.append(this.leftButton_);
        popup.popupWrapper_.append(this.rightButton_);
        popup.popupWrapper_.append(this.content_);
        popup.popupWrapper_.append(this.view_);

        this.setSetpBadge();
        this.setContent();
    },
    setSetpBadge: function () {
        this.stepBadge_.text(['STEP ', this.pageIndex + 1, '/', this.content.length].join(''));
    },
    setContent: function () {
        if(this.content.length > 1) {
            if(this.pageIndex === 0) {
                this.rightButton_.addClass('show');
                this.leftButton_.removeClass('show');
            } else if(this.pageIndex === this.content.length - 1) {
                this.leftButton_.addClass('show');
                this.rightButton_.removeClass('show');
            } else {
                this.rightButton_.addClass('show');
                this.leftButton_.addClass('show');
            }
        } else {
            this.rightButton_.removeClass('show');
            this.leftButton_.removeClass('show');
        }

        this.setSetpBadge();
        var nowContent = this.content[this.pageIndex];
        this.view_.html(nowContent.description);
        this.view_.attr('class', ['entryPopupHelperView', nowContent.descStyle].join(' '));
        this.content_.html('');
        this.content_.attr('class', ['entryPopupHelperContent', nowContent.contentStyle].join(' '));
      
        
        if(nowContent.textSet && nowContent.textSet.length > 0) {
            for(var idx in nowContent.textSet) {
                var item = nowContent.textSet[idx];
                var elem = Entry.Dom('div', {
                    class: 'defaultChildText'
                });
                elem.html(item.text);
                var style = {};
                style.bottom = [item.y, 'px'].join('');
                style.left = [item.x, 'px'].join('');
                if (item.align)
                    style['text-align'] = item.align;

                if(item.align && elem.css('text-align') !== 'center')
                    style.width = '1px';
                elem.css(style);
                this.content_.append(elem);
            }
        }
    },
    setNextStep: function () {
        this.pageIndex++;
        this.setContent();
    },
    setPrevStep: function () {
        this.pageIndex--;
        this.setContent();
    },
    onShow: function () {
        // this.pageIndex = 0;
        // this.setContent();
    }
};
